import React from "react";
import DownVector from "../../images/Svg/DownVector.svg";

const SortButton = ({
  menu,
  setMenu,
  newest,
  old,
  min,
  max,
  title,
  tweets,
}) => {
  return (
    <div className={`flex items-center`}>
      <span className="mr-[8px]">Sort By</span>
      <div className="relative">
        <button
          onClick={() => setMenu(!menu)}
          className="border border-[#E1E1E1] sort-button relative"
        >
          <span>{title}</span>
          <img src={DownVector} alt="" />
        </button>

        {menu && (
          <div className="absolute block text-left top-10 w-[118px] left-0 bg-white  border-[#E1E1E1] rounded-[8px] shadow-md pt-2">
            <p
              onClick={() => newest(tweets)}
              className="py-1 pl-[16px] text-[14px] cursor-pointer hover:bg-[#5463FF] hover:text-white hover:rounded-t-[8px]"
            >
              Latest
            </p>
            <p
              onClick={() => old(tweets)}
              className="py-1 pl-[16px] text-[14px] cursor-pointer hover:bg-[#5463FF] hover:text-white"
            >
              Oldest
            </p>
            <p
              onClick={() => min(true, tweets)}
              className="py-1 pl-[16px] text-[14px] cursor-pointer hover:bg-[#5463FF] hover:text-white"
            >
              Lowest Likes
            </p>
            <p
              onClick={() => max(false, tweets)}
              className="pt-1 pb-[8px] pl-[16px] text-[14px] rounded-b-[8px] cursor-pointer hover:bg-[#5463FF] hover:text-white"
            >
              Highest Likes
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default SortButton;
